import { CheckoutStatus as s } from "@ancon/wildcat-types";
function r(t) {
  switch (t == null ? void 0 : t.status) {
    case s.Processing:
    case s.Authorized:
    case s.Captured:
      return !1;
    default:
      return !0;
  }
}
export {
  r as default
};
